module.exports = __webpack_public_path__ + "static/img/jingying.efb9854b.svg";